import React from 'react';
import { Button, Icon, Modal } from '@scuf/common';
import './ConfirmationDialog-theme.scss';
import { ConfirmationDialogType } from './ConfirmationDialogEnum';
import { useTranslation } from '@scuf/localization';
import { HOCLocalization } from '../../utils/HOC/HOCLocalization';

interface IConfirmationDialogProps {
  type: ConfirmationDialogType;
  title: string;
  onClick: (action: boolean) => void;
  message: string;
  footerMessage?: string;
  open: boolean;
}

const ConfirmationDialog = (props: IConfirmationDialogProps) => {
  const [t] = useTranslation();
  return (
    <Modal
      className={`confirm-dialog modal-style ${props.type}`}
      size="mini"
      closeIcon={true}
      onClose={() => props.onClick(false)}
      open={props.open}
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
    >
      <Modal.Content>
        <Icon
          name="badge-info"
          className={`status-icon ${props.type}`}
          root="common"
          size="medium"
        />
        <span className="heading">{props.title}</span>
        <div className="desc">{props.message}</div>
      </Modal.Content>
      <Modal.Footer>
        <span>{props.footerMessage}</span>
        <Button
          type="link"
          size="small"
          content={t('no')}
          onClick={() => props.onClick(false)}
        />
        <Button
          type="link"
          size="small"
          content={t('yes')}
          onClick={() => props.onClick(true)}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default HOCLocalization(ConfirmationDialog);
